export const HIGHEST_SALARIES_FINLAND_URL_PATHS = {
  en: '/en/resources/jobs-in-finland/highest-salaries-finland',
  fi: '/fi/tyoelama/korkeimmat-palkat-suomessa-alueittain',
  sv: '/sv/arbetsliv/hogsta-lonerna-finland-regioner',
} as const;

export type HighestSalariesFinlandLocale = keyof typeof HIGHEST_SALARIES_FINLAND_URL_PATHS;
